export default "__VITE_ASSET__zwJbGwcc__"